require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/jszip/~/core-js/library/fn/set-immediate.js
// module id = ../../../../jszip/node_modules/core-js/library/fn/set-immediate.js
// module chunks = 3